module.exports = __webpack_public_path__ + "img/rightimage.8dad0ac4.svg";